import Styles from './Source13.scss';

import Template from './Source13.hbs';
import Util from 'util/util';
import YouTubeView from 'views/components/taskGroups/sources/source13/youtube/YouTube';
import NoContentTemplate from 'views/components/taskGroups/sources/source13/noContent.hbs';
import Digistudies from './digistudies/Digistudies.svelte';

// HTML5/YouTube video view
export default class Source13 extends BaseView {

    initialize({
        isDemo,
        isVideoActivity,
        portfolioStyling: isPortfolio,
        activityModel,
    }) {

        this.activityModel = activityModel

        this.setElement(Template({
            Styles,
            isPortfolio,
            isVideoActivity,
            title: Util.renderContentSafely(this.model && this.model.get('title')),

            // the source is used for the video demo tour;
            // do not constrain the width of the video
            isDemo,
        }));

        if (this.model && _.size(this.model.get('source')) && (
            this.model.get('source').fileId || this.model.get('source').hash
        )) {
            _.defer(
                _.bind(
                    this.insertVideo,
                    this, {
                        isDemo,
                        isVideoActivity
                    }
                )
            );
        } else {
            this.$el.append(NoContentTemplate({
                Styles,
                isVideoActivity
            }));
        }

    }

    insertVideo({
        isVideoActivity,
        isDemo: openAndPlay
    }) {

        var videoElement = this.$('.js-video');

        var source = this.model.get('source');

        // In activities (exams) that require fullscreen view, disable the fullscreen feature of the video
        // to prevent collisions
        const disableFullscreen = this.activityModel?.isExamWithFullscreen()

        switch (source.type) {
            case 'upload': {
                // If a start time is set, include #t= in the URL
                const startFragment = source.startTime > 0 ? `#t=${source.startTime}` : ''
                videoElement.html(
                    `<video src="/edu_files/open/${source.fileId}/${source.fileIdHash}${startFragment}" controls${disableFullscreen ? ' controlsList="nofullscreen"' : ''}></video>`
                );
                break;
            }
            case 'digistudies':
                this.addSvelteChildView(
                    videoElement,
                    Digistudies,
                    {
                        fileId: source.fileId,
                        fileIdHash: source.fileIdHash,
                        isVideoActivity
                    }
                );
                break;
            case 'youtube':
                this.addChildView(new YouTubeView({
                    openAndPlay,
                    isVideoActivity,
                    videoHash: source.hash,
                    startTime: source.startTime,
                    disableFullscreen
                }), videoElement)
                break;
        }

    }

}
